<template>
  <div class="apply-button">
    <a-tooltip
      v-if="hasExpired"
      class="btn-ability-msg-tooltip"
      placement="bottomLeft"
      color="#fff"
    >
      <template #title>
        <div class="btn-ability-msg">
          <ExclamationCircleFilled class="err-msg-icon" />
           {{ offlineMode ? $t('user.This Session is Offline') : $t('user.The Project ROAR open window is closed.') }}
        </div>
      </template>
      <a-button
        type="primary"
        :disabled="!isRoleA() || hasExpired || offlineMode"
        class="btn-apply"
      >
        <span>{{ $t('user.' + btnText) }}</span>
      </a-button>
    </a-tooltip>
    <template v-else>
      <a-button type="primary" class="btn-apply" @click="applyApplication">
        <span>{{ $t('user.' + btnText) }}</span>
      </a-button>
    </template>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { ExclamationCircleFilled } from '@ant-design/icons-vue'
  import 'remixicon/fonts/remixicon.css'

  export default {
    name: 'ApplyButton',
    props: {
      btnText: {
        type: String,
        default: 'Apply For ROAR Moment',
      },
      linkUrl: {
        type: String,
        default: '/me/application/apply',
        // required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: { ExclamationCircleFilled },
    data() {
      return {}
    },
    computed: {
      ...mapGetters({
        role: 'acl/role',
        applicationPeriod: 'user/applicationPeriod',
        ability: 'acl/ability',
        offlineMode: 'user/offlineMode'
      }),
      hasExpired() {
        return !this.hasAbility('apply')
      },
    },

    methods: {
      isRoleA() {
        return this.role.indexOf('a') >= 0
      },
      hasAbility(key) {
        const ability = this.ability.find((item) => item.key === key)
        if (ability == null) {
          console.log('getAbility', key)
        }
        return ability != null && ability.value
      },
      applyApplication() {
        this.$router.push({
          path: this.linkUrl,
        })
      },
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .apply-button {
    max-width: 200px;
    .btn-apply {
      color: #fff;
      width: 190px;
      height: 40px;
      margin-top: 24px;
      // margin-bottom: 24px;
      &[disabled] {
        color: #999;
        margin-top: 0;
        background-color: #f5f5f5;
      }
    }
  }
  .btn-ability-msg-tooltip {
    max-width: auto;
  }
  .btn-ability-msg {
    width: 300px;
    font-size: 14px;
    color: #333333;
    line-height: 22px;

    .err-msg-icon {
      font-size: 12px;
      color: #faba16;
      // margin-right: 10px;
    }
  }
</style>
